const defaultToolCategoryStyle = {
  icon: 'border-border/80 bg-card text-primary',
  dot: 'bg-muted-foreground',
}

const toolCategoryStyles = {
  'Revenue & Analytics': {
    icon: 'border-lilac bg-lilac text-midnight',
    dot: 'bg-lilac ring-1 ring-midnight/10',
  },
  'Renewals & Leasing': {
    icon: 'border-sarah-tint bg-sarah-tint text-midnight',
    dot: 'bg-sarah-tint ring-1 ring-midnight/10',
  },
  'Residents & Communications': {
    icon: 'border-pink bg-pink text-midnight',
    dot: 'bg-pink ring-1 ring-midnight/10',
  },
  'Portfolios & Accounts': {
    icon: 'border-sarah bg-sarah text-midnight',
    dot: 'bg-sarah ring-1 ring-midnight/10',
  },
  'Integrations & Data': {
    icon: 'border-chart-3 bg-chart-3 text-midnight',
    dot: 'bg-chart-3 ring-1 ring-midnight/10',
  },
  'AI, Quality & Platform': {
    icon: 'border-canopy bg-canopy text-sarah-tint',
    dot: 'bg-canopy dark:bg-sarah',
  },
}

export function getToolCategoryStyle(category) {
  return toolCategoryStyles[category] ?? defaultToolCategoryStyle
}
